import { Constants } from '@adobe/aem-spa-page-model-manager';

import { ExperienceFragment } from '@/components/ExperienceFragment/ExperienceFragment';
import { Directory as DirectoryUI } from '@/features/Directory';

const Directory = (props) => {
    const { noResultsFragment, searchServerErrorFragment } = props;

    const noResults = noResultsFragment ? (
        <ExperienceFragment
            cqItems={noResultsFragment[Constants.ITEMS_PROP]}
            cqItemsOrder={noResultsFragment[Constants.ITEMS_ORDER_PROP]}
            {...noResultsFragment}
        />
    ) : undefined;

    const error = searchServerErrorFragment ? (
        <ExperienceFragment
            cqItems={searchServerErrorFragment[Constants.ITEMS_PROP]}
            cqItemsOrder={searchServerErrorFragment[Constants.ITEMS_ORDER_PROP]}
            {...searchServerErrorFragment}
        />
    ) : undefined;

    return <DirectoryUI {...props} noResultsComponent={noResults} errorComponent={error} />;
};

export default Directory;
